import { createSlice } from '@reduxjs/toolkit';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';
import { Nullable, User } from '../../types';
import { getUser, listUsers } from '../thunks/user-thunks';
import { ReducerState } from '../configure-store';

export interface UserState extends ReducerState {
    data: Paginated<User>;
    current: Nullable<User>;
}

const initialState: UserState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listUsers.pending, takeOne.pendingActionCase)
            .addCase(listUsers.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listUsers.rejected, takeOne.rejectedActionCase)

            .addCase(getUser.pending, takeOne.pendingActionCase)
            .addCase(getUser.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getUser.rejected, takeOne.rejectedActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
